import React from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../components/customer/Header'
import ProductGrid from '../../components/customer/ProductGrid'
import SearchFilters from '../../components/customer/SearchFilters'
import { useProducts } from '../../hooks/useProducts'
import styles from './Search.module.css'

const Search = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get('q') || '';

  // Construye los filtros desde los searchParams
  const filters = {
    category_slug: searchParams.get('category_slug'),
    min_price: searchParams.get('min_price'),
    max_price: searchParams.get('max_price'),
    sort_by: searchParams.get('sort_by'),
    sort_order: searchParams.get('sort_order'),
    isPrime: searchParams.get('isPrime'),
    isFeatured: searchParams.get('isFeatured'),
    inStock: searchParams.get('inStock'),
    minRating: searchParams.get('minRating')
  };
  // Limpia y convierte los valores
  const cleanFilters = Object.fromEntries(
    Object.entries(filters)
      .filter(([_, value]) => value != null && value !== '')
      .map(([key, value]) => {
        if (key === 'min_price' || key === 'max_price') {
          return [key, value ? parseFloat(value) : undefined];
        }
        if (key === 'minRating') {
          return [key, value ? parseInt(value) : undefined];
        }
        if (['isPrime', 'isFeatured', 'inStock'].includes(key)) {
          return [key, value === 'true'];
        }
        return [key, value];
      })
  );

  // Usa el hook useProducts
  const {
    products,
    pagination,
    loading,
    error,
    applyFilters
  } = useProducts({ ...cleanFilters, search: query });

  const handleFiltersChange = (newFilters) => {
    const filterMap = {
      category_slug: 'category_slug',
      min_price: 'min_price',
      max_price: 'max_price',
      sort_by: 'sort_by',
      sort_order: 'sort_order',
      isPrime: 'isPrime',
      isFeatured: 'isFeatured',
      inStock: 'inStock',
      minRating: 'minRating'
    };
    const updatedParams = new URLSearchParams(searchParams);

    // Si limpiar filtros, borra todos los parámetros de filtro
    if (Object.keys(newFilters).length === 0) {
      Object.values(filterMap).forEach(key => {
        updatedParams.delete(key);
      });
      setSearchParams(updatedParams);
      applyFilters({});
      return;
    }

    // Si hay filtros, actualiza los parámetros
    Object.entries(newFilters).forEach(([key, value]) => {
      const urlKey = filterMap[key] || key;
      if (
        value !== undefined &&
        value !== null &&
        value !== '' &&
        !(typeof value === 'boolean' && value === false)
      ) {
        updatedParams.set(urlKey, value);
      } else {
        updatedParams.delete(urlKey);
      }
    });
    setSearchParams(updatedParams);
    applyFilters(newFilters);
  };

  return (
    <div className={styles.searchPage}>
      <Header />
      <div className={styles.searchContainer}>
        <div className={styles.searchHeader}>
          <h1>
            {query ? `Resultados para "${query}"` : 'Todos los productos'}
          </h1>
          {pagination?.totalCount > 0 && (
            <p className={styles.resultCount}>
              {pagination.totalCount} productos encontrados
            </p>
          )}
        </div>
        <div className={styles.searchContent}>
          <aside className={styles.filtersPanel}>
            <SearchFilters
              filters={cleanFilters}
              onFiltersChange={handleFiltersChange}
            />
          </aside>
          <main className={styles.resultsPanel}>
            <ProductGrid
              products={products}
              loading={loading}
              error={error}
            />
            {loading && (
              <div className={styles.loadingMore}>
                Cargando productos...
              </div>
            )}
            {!loading && products.length === 0 && (
              <div className={styles.endMessage}>
                No se encontraron productos
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  )
}

export default Search